import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faUsers, faUserFriends, faFileAlt, faPuzzlePiece, faPoll, faAward, faHandHoldingUsd, faTools, faChalkboard, faListDots, faPen } from '@fortawesome/free-solid-svg-icons';
import './AuthorDesk.css';
import authordeskimage from '../../assets/pageimages/AuthorDesk.webp';

const categories = [
  { to: "/authordesk-bookmasters", icon: faListDots, label: "My Book Masters", bgColor: "bg-indigo-600", textColor: "text-white", isActive: true },
  { to: "/authordesk-dictasets", icon: faPen, label: "My DictaBook Sets", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-bookmaster/add", icon: faBook, label: "Publish Books", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-create-practicesets", icon: faPen, label: "Authoring Practice Sets", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-create-certificatetest", icon: faPen, label: "Authoring Certification Exam Sets", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-create-assignments", icon: faPen, label: "Authoring Assignments", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-customers", icon: faUsers, label: "Customers", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-readers", icon: faUserFriends, label: "Readers", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-create-testbooks", icon: faFileAlt, label: "Create TestBooks", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-create-quizzes", icon: faPuzzlePiece, label: "Create Quizzes", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-results", icon: faPoll, label: "Results", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-certificates", icon: faAward, label: "Certificates", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-workshops", icon: faChalkboard, label: "My Workshops", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-my-royalties", icon: faHandHoldingUsd, label: "My Royalties", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-my-setup", icon: faTools, label: "My Setup", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
  { to: "/authordesk-cafebulletins", icon: faTools, label: "CAFE Bulletin", bgColor: "bg-indigo-600", textColor: "text-white", isActive: true },
  { to: "/authordesk-tonicknowledges", icon: faTools, label: "Tonic Knowledge", bgColor: "bg-indigo-600", textColor: "text-white", isActive: true },
  { to: "/authordesk-create-tonicquiz", icon: faTools, label: "Create Tonic Quizzes", bgColor: "bg-indigo-600", textColor: "text-white", isActive: false },
];

function AuthorDeskHome() {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [accessData, setAccessData] = useState(null);
  const [error, setError] = useState(null);


  useEffect(() => {
      const config = { 
        url: "/authoraccess", 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {userCode: userCode}
      };

      fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log('Response for user access:', data.accessData);
        setAccessData({
            accessGrantDate: data.accessData.accessGrantDate,
            isActive: data.accessData.isActive,
        });
      })
      .catch((error) => {
        console.error("Error fetching Author Access data:", error);
        setError("Error fetching Author Access data");
      });
  }, [authState, fetchData, setAccessData]);

  return (
    <div className="min-h-screen bg-black text-white [&_p]:text-white py-2">
      <div className="flex flex-col items-center p-4 bg-black min-h-screen">
        {/* <img
          src={authordeskimage}
          alt="Life Chronicles"
          className="w-full h-64 object-cover mb-6 rounded-lg shadow-lg"
        /> */}
        <h1 className="text-lg lg:text-xl font-extrabold mb-6 text-yellow-200">✍️ Author Desk</h1>
        {accessData !== null ? 
          (
            <div className="grid grid-cols-2 lg:grid-cols-6 gap-6">
              {categories.map((category, index) => {
                const baseClasses =
                  "w-full h-12 lg:h-20 text-gray-100 flex flex-col items-center justify-center rounded-xl shadow-md transition-all duration-300";

                const activeClasses = `${category.bgColor} ${category.textColor} hover:text-yellow-200 cursor-pointer`;

                const inactiveClasses =
                  "bg-gray-300 text-gray-600 opacity-70 cursor-not-allowed";

                const content = (
                  <>
                    <FontAwesomeIcon
                      icon={category.icon}
                      size="lg"
                      className="mb-2"
                    />
                    <span className="text-xs lg:text-sm font-semibold text-center px-1">
                      {category.label}
                    </span>
                  </>
                );

                return category.isActive ? (
                  <Link
                    key={index}
                    to={category.to}
                    className={`${baseClasses} ${activeClasses}`}
                  >
                    {content}
                  </Link>
                ) : (
                  <div key={index} className={`${baseClasses} ${inactiveClasses}`}>
                    {content}
                  </div>
                );
              })}
            </div>
          ) : (
              <div className='text-lg lg:text-xl text-red-500 flex flex-col items-center justify-center'>
                  <p>Access Denied!!</p>
                  <p>You need to activate your account as an Author on the Think5Whys Platform!</p>
              </div>
        )}
      </div>
    </div>
  );
}


export default AuthorDeskHome;



{/* <div className="flex flex-col items-center p-4 bg-gray-100 min-h-screen mt-12">
        <div className="container mx-auto px-4 py-6 mt-12">
          <div className="flex justify-center mb-6">
            <img 
              src={authordeskimage} 
              alt="AuthorDesk" 
              className="w-full h-auto max-w-full mx-auto rounded-lg shadow-md"
              style={{ maxHeight: '300px', objectFit: 'contain' }} // Prevents stretching
            />
          </div>
          <h2 className='text-3xl font-bold text-white text-center mb-6'>AuthorDesk</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mb-8 w-full">
            <Link to="/authordesk-bookmasters" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faListDots} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">My Book Masters</span>
            </Link>
            <Link to="/authordesk-dictaset" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faPen} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">My DictaBook Sets</span>
            </Link>
            <Link to="/authordesk-bookmaster/add" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faBook} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Publish Books</span>
            </Link>
            <Link to="/authordesk-customers" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faUsers} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Customers</span>
            </Link>
            <Link to="/authordesk-readers" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faUserFriends} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Readers</span>
            </Link>
            <Link to="/authordesk-create-testbooks" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faFileAlt} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Create TestBooks</span>
            </Link>
            <Link to="/authordesk-create-quizzes" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faPuzzlePiece} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Create Quizzes</span>
            </Link>
            <Link to="/authordesk-results" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faPoll} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Results</span>
            </Link>
            <Link to="/authordesk-certificates" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faAward} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">Certificates</span>
            </Link>
            <Link to="/authordesk-workshops" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faChalkboard} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">My Workshops</span>
            </Link>
            <Link to="/authordesk-my-royalties" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faHandHoldingUsd} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">My Royalties</span>
            </Link>
            <Link to="/authordesk-my-setup" className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-md hover:bg-gray-200 transition">
              <FontAwesomeIcon icon={faTools} className="text-2xl mb-2 text-gray-600" />
              <span className="text-sm text-gray-700">My Setup</span>
            </Link>
          </div>
        </div>
      </div> */}
